import Actions from "views/Actions/Actions.jsx";
import JobApplication from "views/JobApplication/JobApplication.jsx";
import Brokers from "views/Brokering/Brokers.jsx";
import Orders from "views/Brokering/Orders.jsx";
import UserProfile from "views/Profile/userProfile.jsx";
import ShipperProfile from "views/Profile/shipperProfile.jsx";
import VendorProfile from "views/Profile/vendorProfile.jsx";
import OrderProfile from "views/Profile/orderProfile.jsx"; 
import QuoteProfile from "views/Profile/quoteProfile.jsx";
import Profile from "views/Profile/Profile.jsx";
import PendingActions from "views/Admin/PendingActions.jsx";
import Users from "views/Admin/Users.jsx";
import Vendors from "views/Admin/Vendors.jsx";
import pagesRoutes from "./pages.jsx";

// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import Apps from "@material-ui/icons/Apps";
import Contacts from "@material-ui/icons/Contacts";
import AttachMoney from "@material-ui/icons/AttachMoney";
import LoopIcon from '@material-ui/icons/Loop';
import BuildIcon from '@material-ui/icons/Build';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import MapIcon from '@material-ui/icons/Map';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ExploreIcon from '@material-ui/icons/Explore';
// import ContentPaste from "@material-ui/icons/ContentPaste";

import Place from "@material-ui/icons/Place";
import Timeline from "@material-ui/icons/Timeline";
import Ship from "../views/Ship/Ship.jsx";
import PlaceOrder from "../views/Customer/PlaceOrder.jsx";
import CurrentOrders1 from "../views/Customer/CurrentOrders1.jsx";
import Lanes from "../views/Lanes/Lanes.jsx";
import Rates from "../views/Rates/Rates.jsx";
import FeedForms from "../components/Forms/FeedForms.jsx"
import Dispatch from "../views/Dispatch/DispatchParent.jsx";
import Quote from "../views/Dispatch/QuoteParent.jsx";
import Carriers from "../views/Admin/Carriers.jsx";
import DispatchedOrders from "../views/Dispatch/DispatchedOrdersParent.jsx";
import DispatchedOrdersDriver from "../views/Driver/DispatchedOrders.jsx";
import ConfirmedOrders from "../views/Dispatch/ConfirmedOrders.jsx";
import DispatchedOrders1 from "../views/Driver/DispatchedOrders1.jsx";
import SettingsApplications from '@material-ui/icons/SettingsApplications';
import ContactSupport from '@material-ui/icons/ContactSupport';
import LocalShipping from '@material-ui/icons/LocalShipping';
import PersonIcon from '@material-ui/icons/Person';
import LocalAtm from '@material-ui/icons/LocalAtm';
import History from '@material-ui/icons/History';
import NotificationImportant from '@material-ui/icons/NotificationImportant';
import Receipt from '@material-ui/icons/Receipt';
import BusinessIcon from '@material-ui/icons/Business';
import Shippers from "../views/Admin/Shippers.jsx";
import companyProfile from "../views/Profile/companyProfile.jsx";
import CompletedOrders from "../views/Dispatch/CompletedOrdersParent.jsx";
import CancelledOrders from "../views/Dispatch/CancelledOrdersParent.jsx";
import Flights from "../views/Flights/Flights.jsx";
import OrdersDetails from "../views/Orders/OrdersDetails.jsx";
import QB from "../views/Orders/QB.jsx";
import Quoted from "../views/Dispatch/QuotedParent.jsx";
import Explore from "../views/Explore/Explore.jsx";
import ExploreTemp from "../views/ExploreTemp/Explore.jsx";
import ExploreGroups from "../views/ExploreTemp/ExploreGroups.jsx";
import DocumentDetails from "../views/ExploreTemp/DocumentDetails.jsx";
import GroupDetails from "../views/Profile/groupProfile.jsx";
import InTransitOrders from "../views/Dispatch/InTransitOrdersParent.jsx";
import DockedOrders from "../views/Dispatch/DockedOrdersParent.jsx";
import AllOrders from "../views/Dispatch/AllOrdersParent.jsx";
import AROrders from "../views/Dispatch/AROrdersParent.jsx";
import ARCustomerOrders from "../views/Dispatch/ARCustomerOrders.jsx";
import CollectionsOrders from "../views/Dispatch/CollectionsOrdersParent.jsx";
import Deposits from "../views/Dispatch/DepositsParent.jsx";
import PickUpsOrders from "../views/Dispatch/PickUpsOrdersParent.jsx";
import DeliveriesOrders from "../views/Dispatch/DeliveriesOrdersParent.jsx";
import NotificationsParent from "../views/Customer/NotificationsParent.jsx"
import DispatchOrderForm from "../components/Forms/DispatchOrderForm2.jsx";
import TripBuilder from "../views/Trips/TripBuilder.jsx";
import TripsTable from "../views/Trips/TripsTable.jsx";
import SettlementsTable from "../views/Settlements/SettlementsTable.jsx";
import TripViewer from "../views/Trips/TripViewer.jsx";
import TripEditor from "../views/Trips/TripEditor.jsx";
import SettlementEditor from "../views/Settlements/SettlementEditor.jsx";
import TripBuilderParent from "../views/Trips/TripBuilderParent.jsx";
import SettlementsBuilderParent from "../views/Settlements/SettlementsBuilderParent.jsx";

export default [
  // {
  //   collapse: true,
  //   admin: true,
  //   path: "/admin",
  //   name: "Admin",
  //   icon: DashboardIcon,
  //   views: [
  //     { path: "/admin/users", name: "Users", icon: ContactSupport, component: Users },   
  //   ]
  // }, 
  { path: "/ship", name: "SHIP", icon: LocalShipping, component: FeedForms },
  { path: "/dashboard", name: "DASHBOARD", icon: DashboardIcon, component: Actions },   
  // { path: "/company", name: "COMPANY", icon: BusinessIcon, component: companyProfile }, 
  // { path: "/users", admin: true, name: "USERS", icon: PersonIcon, component: Users },   
  { path: "/user/:id", admin: true, name: "USER PROFILE", icon: PersonIcon, component: UserProfile },   
  // { path: "/shippers", name: "SHIPPERS", icon: Contacts, component: Shippers },   
  { path: "/shipper/:id", admin: true, name: "SHIPPER PROFILE", icon: PersonIcon, component: ShipperProfile },   
  { path: "/quote/:id", admin: true, name: "SHIPPER PROFILE", icon: PersonIcon, component: FeedForms },   
  { path: "/order/:id", admin: true, name: "SHIPPER PROFILE", icon: PersonIcon, component: OrdersDetails },   
  { path: "/qb", admin: true, name: "SHIPPER PROFILE", icon: PersonIcon, component: QB },   
  // { path: "/vendors/", name: "VENDORS", icon: Contacts, component: Vendors },   
  { path: "/vendor/:id", admin: true, name: "VENDOR PROFILE", icon: PersonIcon, component: VendorProfile },   
  // { path: "/vendors/", admin: true, name: "VENDOR PROFILE", icon: PersonIcon, component: Vendors },   
  // { path: "/shippers/", admin: true, name: "VENDOR PROFILE", icon: PersonIcon, component: Shippers },   
  { path: "/explore/:id/explore", name: "Explore Test", admin: true, icon: Contacts, component: ExploreTemp },
  { path: "/explore/:id/:docid", name: "Explore", admin: true, icon: Contacts, component: DocumentDetails },
  { path: "/groups/:id", name: "Explore", admin: true, icon: Contacts, component: GroupDetails },
  { path: "/flight/:id", admin: true, name: "FLIGHTS", icon: PersonIcon, component: Flights },   
  { path: "/dispatch/order/:id", admin: true, name: "FLIGHTS", icon: PersonIcon, component: DispatchOrderForm },

  {
    collapse: true,
    path: "/orders",
    name: "ORDERS",
    icon: AssignmentIcon,
    state: "openOrders",
    views: [
      { path: "/orders/pending-orders", name: "PENDING ORDERS", component: Quote },   
      { path: "/orders/quoted-orders", name: "QUOTED ORDERS", component: Quoted },  
      { path: "/orders/booked-orders", name: "BOOKED ORDERS", component: Dispatch },  
      { path: "/orders/dispatched-orders", name: "DISPATCHED ORDERS", component: DispatchedOrders },  
      { path: "/orders/in-transit-orders", name: "IN TRANSIT ORDERS", component: InTransitOrders },  
      { path: "/orders/docked-orders", name: "DOCKED ORDERS", component: DockedOrders },  
      { path: "/orders/delivered-orders", name: "DELIVERED ORDERS", component: CompletedOrders },  
      { path: "/orders/cancelled-orders", name: "CANCELED ORDERS", component: CancelledOrders }, 
      { path: "/orders/all-orders", name: "ALL ORDERS", component: AllOrders },
      { path: "/orders/pickups-today", name: "PICKUPS TODAY", component: PickUpsOrders },
      { path: "/orders/deliveries-today", name: "DELIVERIES TODAY", component: DeliveriesOrders } 
    ]
  }, 
  {
    collapse: true,
    path: "/trips",
    name: "TRIPS",
    icon: ExploreIcon, 
    views: [
      { path: "/trips/alltrips", name: "ALL TRIPS", component: TripsTable },
      { path: "/trips/otrtrips", name: "OTR TRIPS", component: TripsTable },
      { path:"/trips/brokertrips", name: "BROKER TRIPS", component: TripsTable },    
      { path: "/trips/localtrips", name: "LOCAL TRIPS", component: TripsTable }
    ]
  },


  { path: "/trips/create", name: "TRIP BUILDER", icon: BuildIcon, component: TripBuilderParent },
  // { path: "/trips/:id/edit", admin: true, name: "TRIPS", icon: SyncAltIcon, component: TripEditor },
  { path: "/trips/:id", admin: true, name: "TRIPS", icon: MapIcon, component: TripEditor },
  {
    collapse: true,
    path: "/settlements",
    name: "ACCOUNTING",
    icon: AttachMoney, 
    state: "openSettlements",
    views: [
      { path: "/settlements/arcustomerorders", name: "AR CUSTOMER SUMMARY REPORT", component: ARCustomerOrders },
      // { path: "/settlements/arorders", name: "AR ORDER LEVEL SEARCH", component: AROrders },
      { path: "/settlements/allsettlements", name: "SETTLEMENT SUMMARY REPORT", component: SettlementsTable },
      { path: "/settlements/collectionsorders", name: "COLLECTIONS REPORT", component: CollectionsOrders },
      { path: "/settlements/deposits", name: "DEPOSITS REPORT", component: Deposits },
      { path: "/settlements/create", name: "SETTLEMENT BUILDER", icon: BuildIcon, component: SettlementsBuilderParent }
    ]
  },
  { path: "/settlements/:id", admin: true, name: "TRIPS", icon: MapIcon, component: SettlementEditor },
  {
    collapse: true,
    path: "/entities",
    name: "NETWORK",
    icon: Contacts,
    state: "openEntities",
    views: [
      { path: "/groups", name: "GROUPS", component: ExploreGroups },
      { path: "/explore/haney-shippers/explore", name: "SHIPPERS", component: ExploreTemp },
      { path: "/explore/haney-vendors/explore", name: "VENDORS", component: ExploreTemp },
      { path: "/directory/users", name: "USERS", component: Explore },  
    ]
  },
  { path: "/notifications",  name: "NOTIFICATIONS", icon: NotificationImportant, component: NotificationsParent },
  { path: "/profile", name: "PROFILE", icon: PersonIcon, component: Profile }, 

];





// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx